import { useParams } from "react-router";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { jobEmails, jobEmailKeys } from "@/lib/job-emails";
import { JobEmailThread } from "@/components/job-email-thread";
import { PageContainer } from "@/app/layouts/PageContainer";

export function JobEmailsFullPage() {
  const { id } = useParams<{ id: string }>();
  const jobId = Number(id);
  const qc = useQueryClient();
  const { data = [] } = useQuery({
    queryKey: jobEmailKeys.thread(jobId),
    queryFn: () => jobEmails.list(jobId),
  });
  const send = useMutation({
    mutationFn: (body: { toEmailAddress: string; subject: string; htmlBody: string }) =>
      jobEmails.send(jobId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: jobEmailKeys.thread(jobId) }),
  });
  return (
    <PageContainer>
      <div className="max-w-4xl space-y-4">
        <h1 className="text-2xl font-bold">Job {jobId} — Emails</h1>
        <JobEmailThread jobId={jobId} emails={data} onSend={(body) => send.mutate(body)} />
      </div>
    </PageContainer>
  );
}
